import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import './nav.css';
import logo from './logo.svg';
import apiClient from '../../networking/APIClient';

class Nav extends Component {

  render() {
    return (
      <div className="nav">
        <div className="logo">
          <a href="/"><img src={logo} alt="PaceUP!" className="logo" /></a>
        </div>        
      </div>
    );
  }

}

export default withRouter(Nav);



// WEBPACK FOOTER //
// ./src/components/nav/nav.js